import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=051249d1&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&id=051249d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051249d1",
  null
  
)

export default component.exports